/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Service from '../Util/Service';
import $ from '../Util/Util';
import FolderOpenIcon from './opened-folder.png';
import FolderCloseIcon from './closed-folder.png';
import EntityIcon from './baseline_description_black_24dp.png';
import './Entityselector.css';

/**
 * Represents an entity selector component.
 */

export default class Entityselector extends Component {

    /**
     * Properties.
     */

    static propTypes = {
        context:             PropTypes.object.isRequired,
        height:              PropTypes.number.isRequired,        
        onLoading:           PropTypes.func.isRequired
    }

    /**
     * Default state.
     */

    state = {
        folders:           [],
        entity:            null
    }

    /**
     * Event that fires when the user toggles a folder.
     * 
     * @param  {String}    folder      folder ID that is toggled
     */

    _toggleFolder = (folder) => {

        // Getting the DOM folder and the visibility state

        let fld = ReactDOM.findDOMNode(this['folder_' + folder]);
        let state = fld.style.display !== 'none';

        // Toggling the icon of the folder

        ReactDOM.findDOMNode(this['foldericon_' + folder]).src = state ? FolderCloseIcon : FolderOpenIcon;
        
        // Refreshing the folders

        fld.style.display = (state ? 'none' : '');
    }

    /**
     * Event that fires when the user selects an entity.
     * 
     * @param  {Object}    entity       selected entity
     */

    _selectEntity = (entity) => {

        // Getting the DOM entity

        let ent = ReactDOM.findDOMNode(this['entity_' + entity.id]);
        
        // Toggling or deselecting the entity

        if (!ent.classList.contains('dashboard-entity-selected')) {
            if (this.state.entity) {
                ReactDOM.findDOMNode(this['entity_' + this.state.entity.id]).className = 'dashboard-entity dashboard-entity-unselected';
            }
    
            ent.className = 'dashboard-entity dashboard-entity-selected';

            // Storing the selected entity

            this.setState({ entity: entity });
        }
    }

    /**
     * Gets the selected entity.
     * 
     * @return  {Object}    entity      selected entity
     */

    getSelectedEntity = () => {
        return this.state.entity;
    }

    /**
     * Loads the folder tree that is available for the current user.
     * 
     * @return  {Promise}   promise     promise object
     */

    load = () => {

        // Creating and returning the promise object

        return new Promise((resolve, reject) => {

            // Showing progress indicator

            this.props.onLoading(true);

            // Getting the folders

            Service.loadDashboard(this.props.context.user.admin ? null : this.props.context.user.group.id).then((folders) => {

                // Storing the folder tree and the list

                this.setState({ folders: folders });

                // Hiding progress indicator

                this.props.onLoading(false);

                // Resolving

                resolve();
            }).catch((error) => {

                // Hiding progress indicator

                this.props.onLoading(false);

                // Showing error

                $.fireEvent('snackbar', { message: this.props.context.locale.error.database, error: true });

                // Rejecting

                reject();
            });
        });
    }

    /** 
     * Entity selector renderer.
     */

    render() {

        /**
         * Renders the folder tree.
         * 
         * @param {Array}   folder  folders that has to render 
         * @param {Number}  level   current folder level 
         */

        let renderFolder = (folder, level) => {
            return (
                folder.map((item, index) => {
                    return (
                        <div key={item.id} style={{ position: 'relative', left: (level === 1 ? 0 : 32) + 'px', width: `calc(100% - ${level === 1 ? 0 : 32}px)` }}>

                            {/* Folder */}

                            { !item.entitytype &&
                                <div className="entityselector-folder" onClick={this._toggleFolder.bind(this, item.id)}>
                                    <div className="horizontal center">
                                        <img ref={c => {this['foldericon_' + item.id] = c;}} alt="Folder" src={FolderCloseIcon} className="entityselector-folder-icon" />
                                        <div className="entityselector-folder-label">{item.name}</div>
                                    </div>
                                </div>
                            }

                            {/* Entity */}

                            { item.entitytype &&
                                <div ref={c => {this['entity_' + item.id] = c;}} className="entityselector-entity entityselector-entity-unselected" onClick={this._selectEntity.bind(this, item)}>
                                    <div className="horizontal center">
                                        <img alt="Entity" src={EntityIcon} className="entityselector-entity-icon" />
                                        <div className="entityselector-entity-label">{item.name}</div>
                                    </div>
                                </div>
                            }

                            {/* Subfolder and entities holder */}
                            
                            { !item.entitytype &&
                                <div ref={c => {this['folder_' + item.id] = c;}} style={{ display: 'none' }}>

                                    {/* Subfolders of the folder */}

                                    { item.folders && renderFolder(item.folders, level + 1)}
        
                                    {/* Entities of the folder */}

                                    { item.entities && renderFolder(item.entities, level + 1)}
                                </div>
                            }
                        </div>
                    );                    
                })
            );
        };

        return (

            /* Folder tree container*/

            <div ref={c => {this.root = c;}} className="entityselector" style={{ height: this.props.height + 'px' }}>

                {/* Folder tree */}

                <div className="entityselector-folder-container vertical">
                    { renderFolder(this.state.folders, 1) }
                </div>
            </div>
        )
    }    
}



// WEBPACK FOOTER //
// ./src/components/Entityselector/Entityselector.js